import React from "react";

import * as d3 from "d3";

import { generateLabelProgression } from "../helper";

import { Axis, Text } from "./style";

type AxisProps = {
  numProgression: number;
  maxPoint?: number;
  xAxis?: d3.ScaleTime<any, any>;
  yAxis?: d3.ScaleLinear<any, any>;
  format: (d: any) => string | number;
  transform: string;
};
const Yaxis = ({
  numProgression,
  maxPoint,
  xAxis,
  yAxis,
  format,
  transform
}: AxisProps) => {
  const progression = generateLabelProgression(numProgression, maxPoint);

  return (
    <Axis className="y-axis" transform={transform}>
      {progression.map((p, i) => {
        return (
          <g key={i} className="tick">
            <Text x={xAxis?.range()[0]} y={yAxis?.(p)}>
              {format(p)}
            </Text>
          </g>
        );
      })}
    </Axis>
  );
};

export default Yaxis;
